// verification-skip.js
//
// "Completar después" del wizard de verificación.
//
// Durante la DEMO el médico tiene que poder entrar sin frenar en el carnet, el
// certificado de la Superintendencia y el N° de registro: pedirlos de entrada
// entorpece el flujo y mata la demo. Post-demo, para la venta oficial, los tres
// se exigen sí o sí.
//
// El skip es SOLO local (localStorage) y NO le manda nada al backend a
// propósito. Dos razones:
//   1. El backend rechaza el envío incompleto igual: ProfileDocumentsSerializer
//      exige id_document + health_certificate (required=True) y N° de registro
//      (o universidad) en validate(). Un "guardar a medias" no existe.
//   2. Aunque existiera, mandaría el perfil a verification_status=PENDING, o
//      sea a la cola de revisión de un admin, con los documentos incompletos.
//      Hoy esa cola tiene 7 perfiles sin resolver, el más viejo de 99 días
//      (Planner #903): sumarle perfiles vacíos la vuelve más inútil todavía.
// Al no enviar nada, el perfil queda en NOT_SUBMITTED, que es la verdad: no
// entregó su verificación. El pendiente nos sigue quedando visible.

const KEY = "smartdx:verification_skipped";

const keyFor = (user) => `${KEY}:${user?.id ?? user?.username ?? "anon"}`;

export const markVerificationSkipped = (user) => {
  try {
    window.localStorage.setItem(keyFor(user), "1");
  } catch (e) {
    // Safari en modo privado tira acá. Si no se puede persistir, el gate
    // vuelve a aparecer en la próxima navegación: molesto, no roto.
  }
};

export const isVerificationSkipped = (user) => {
  try {
    return window.localStorage.getItem(keyFor(user)) === "1";
  } catch (e) {
    return false;
  }
};

export const clearVerificationSkip = (user) => {
  try {
    window.localStorage.removeItem(keyFor(user));
  } catch (e) {
    // noop
  }
};
